import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { BackgroundPreview, LabelPreview, ColorsFormWrapper } from 'src/main/cms/Sports/SportsForm/AddSportColorsForm.style';
import { ColorPicker } from 'src/main/cms/Sports/SportsForm/ColorPicker/ColorPicker';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ColorPickersWrapper } from './ColorPicker/ColorPicker.style';

interface ImageUploadFormPropsTypes {
    label?: string;
    textColor: FormInputState<string, string>;
    bgColor: FormInputState<string, string>;
    sportLabel: string;
    setHeaderTextColor: (value: string) => void;
    setHeaderBgColor: (value: string) => void;
    resetColors: () => void;
}

export const AddSportColorsForm = observer('AddColorsForm', (props: ImageUploadFormPropsTypes) => {
    const { sportLabel, textColor, bgColor, setHeaderTextColor, setHeaderBgColor, resetColors } = props;

    return (
        <ColorsFormWrapper>
            <Button version='secondary' size='small' onClick={resetColors}>Reset to default</Button>
            <BackgroundPreview bgColor={bgColor.value} textColor={textColor.value} data-test='custom-colors-preview'>
                <LabelPreview>{sportLabel}</LabelPreview>
            </BackgroundPreview>

            <ColorPickersWrapper>
                <ColorPicker setColor={setHeaderTextColor} label={'Text'} color={textColor}></ColorPicker>
                <ColorPicker setColor={setHeaderBgColor} label={'Background'} color={bgColor}></ColorPicker>
            </ColorPickersWrapper>
        </ColorsFormWrapper>
    );
});
